import { composeReducers } from 'common/util/composeReducers';
import lodash from 'lodash';

import { SET_QUERY,
    SET_FILTER_OPTIONS,
    SET_FILTER2_OPTIONS,
    SET_SORT_OPTIONS,
    SET_SORT_ORDER_OPTIONS,
    SET_SEARCH_PLACEHOLDER_TEXT } from 'common/actions/searchContainerActions';

export function setQuery(state, action){
    if(!action || action.type !== SET_QUERY){
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'app.search.query', action.payload);
    return newState;
}

export function setFilterOptions(state, action){
    if(!action || action.type !== SET_FILTER_OPTIONS){
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'app.search.filterOptions', action.payload);
    return newState;
}

export function setFilter2Options(state, action){
    if(!action || action.type !== SET_FILTER2_OPTIONS){
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'app.search.filter2Options', action.payload);
    return newState;
}

export function setSortOptions(state, action){
    if(!action || action.type !== SET_SORT_OPTIONS){
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'app.search.sortOptions', action.payload);
    return newState;
}

export function setSortOrderOptions(state, action){
    if(!action || action.type !== SET_SORT_ORDER_OPTIONS){
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'app.search.sortOrderOptions', action.payload);
    return newState;
}

export function setSearchPlaceholderText(state, action){
    if(!action || action.type !== SET_SEARCH_PLACEHOLDER_TEXT) {
        return state;
    }
    const newState = lodash.clone(state);
    lodash.set(newState, 'app.search.placeholderText', action.payload);
    return newState;
}

export default composeReducers(
    setQuery,
    setFilterOptions,
    setFilter2Options,
    setSortOptions,
    setSortOrderOptions,
    setSearchPlaceholderText
);
